import WarningTriangleOrangeSmallPath from "@ingka/ssr-icon/paths/warning-triangle-orange-small";

export default WarningTriangleOrangeSmallPath;
